module.exports = __webpack_public_path__ + "static/media/VerticalBasic800.8f35c388.svg";